var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var throttle = require('lodash.throttle');

function Concierge(el) {
	var t = this;

	t.el = el;
	t.start = document.querySelector( t.el.getAttribute('data-modal-start') );
	t.end = document.querySelector( t.el.getAttribute('data-modal-end') );
	t.closeButton = t.el.querySelector('.js-concierge-close');
	t.activeClass = 'concierge--visible';

	if( t.start && t.end ) {
		t.init();
	}

	if ( t.closeButton ) {
		t.closeButton.addEventListener('click', t.closeModal.bind(t));
	}

	$(window).load(function() {
		$(t.el).insertAfter($(t.start).find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, [tabindex], [contentEditable=true]').first());
	});
}

Concierge.prototype.init = function() {
	var t = this,
			start = t.start.offsetTop - window.innerHeight / 2,
			end = t.end.offsetTop - window.innerHeight / 2;

	if( start && end ) {
		window.addEventListener('scroll', throttle(function () {
			var offset = window.pageYOffset;
			if (offset > start && offset < end) {
				t.el.classList.add( t.activeClass );
			} else {
				t.el.classList.remove( t.activeClass );
			}
		}, 300));
	}
};

Concierge.prototype.closeModal = function() {
	var t = this;
	t.el.classList.remove( t.activeClass );
	setTimeout(function () {
		t.el.remove();
	},300);
};

module.exports = Concierge;
